import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { NgMapsCoreModule } from '@ng-maps/core';
import { NgMapsGoogleModule } from '@ng-maps/google';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ClipboardModule } from 'ngx-clipboard';
import { AppPipesModule } from 'src/app/modules/app-pipes/app-pipes.module';
import { ImmoIPPlacerSubProjectSearchComponent } from '../../placer-navbar/immo-ip-placer-subproject-search/immo-ip-placer-subproject-search.component';
import { SharedModule } from '../../shared/shared.module';
import { ImmoIpComponent } from './immo-ip.component';
import { ImmoRedirectLandingPageComponent } from './immo-redirect-landing-page/immo-redirect-landing-page.component';
import { AppointmentImmoOverviewComponent } from './overview/appointment/appointment-immo-overview.component';
import { AppointmentNewImmoOverviewComponent } from './overview/appointment/new/appointment-new-immo-overview.component';
import { AppointmentNoTourImmoOverviewComponent } from './overview/appointment/no-tour/appointment-no-tour-immo-overview.component';
import { ImmoBillingDetailComponent } from './overview/billing-detail/immo-billing-detail.component';
import { ImmoBillingOverviewComponent } from './overview/billing/immo-billing-overview.component';
import { CompletedImmoOverviewComponent } from './overview/completed/completed-immo-overview.component';
import { DelayedImmoOverviewComponent } from './overview/delayed/delayed-immo-overview.component';
import { DesignImmoOverviewComponent } from './overview/design/design-immo-overview.component';
import { ImmoPrintTablesComponent } from './overview/immo-print-tables/immo-print-tables.component';
import { ImmoTaskOverviewComponent } from './overview/immo-task/immo-task-overview.component';
import { ImmoJobClientOverviewComponent } from './overview/job/immo-job-client-overview/immo-job-client-overview.component';
import { ImmoJobOverviewComponent } from './overview/job/immo-job-overview/immo-job-overview.component';
import { ImmoJobYearOverviewComponent } from './overview/job/immo-job-year-overview/immo-job-year-overview.component';
import { NewImmoOverviewComponent } from './overview/new/new-immo-overview.component';
import { NonExecutedImmoOverviewComponent } from './overview/non-executed/non-executed-immo-overview.component';
import { PrintImmoOverviewComponent } from './overview/print/print-immo-overview.component';
import { StudioImmoOverviewComponent } from './overview/studio/studio-immo-overview.component';
import { TextImmoOverviewComponent } from './overview/text/text-immo-overview.component';
import { CompletedAssignmentModalComponent } from '../../shared/completed-assignment-modal/completed-assignment-modal.component';
import { ImmoIPPlacerProjectCompletionPicturesComponent } from './placer/tour-item-detail/completion/immo-ip-placer-project-completion-pictures/immo-ip-placer-project-completion-pictures.component';
import { ImmoIPPlacerProjectCompletionComponent } from './placer/tour-item-detail/completion/immo-ip-placer-project-completion.component';
import { ImmoIPPlacerTourItemDetailComponent } from './placer/tour-item-detail/immo-ip-placer-tour-item-detail.component';
import { ImmoIPPlacerImmoTaskDetailComponent } from './placer/tour-item-detail/immo-task/immo-ip-placer-immo-task-detail.component';
import { ImmoIPPlacerImmoTaskExecutionAssetsComponent } from './placer/tour-item-detail/immo-task/immo-ip-placer-immo-task-execution-assets/immo-ip-placer-immo-task-execution-assets.component';
import { ImmoIPPlacerImmoTaskHeader } from './placer/tour-item-detail/immo-task/immo-ip-placer-immo-task-header/immo-ip-placer-immo-task-header.component';
import { ImmoIPPlacerTourItemDetailNotExecutedAssetsComponent } from './placer/tour-item-detail/not-executed-modal/assets/immo-ip-placer-tour-item-detail-not-executed-assets.component';
import { ImmoIPPlacerTourItemDetailNotExecutedModalComponent } from './placer/tour-item-detail/not-executed-modal/immo-ip-placer-tour-item-detail-not-executed-modal.component';
import { ImmoIPPlacerTourViewComponent } from './placer/tour-view/immo-ip-placer-tour-view.component';
import { ImmoIPPlacerTourListComponent } from './placer/tour-view/tour-list/immo-ip-placer-tour-list.component';
import { ImmoIPPlacerTourRouteMapComponent } from './placer/tour-view/tour-route/immo-ip-placer-tour-route-map/immo-ip-placer-tour-route-map.component';
import { ImmoIPPlacerTourRouteComponent } from './placer/tour-view/tour-route/immo-ip-placer-tour-route.component';
import { CreateEditTaskModalComponent } from './task/create-edit-task/create-edit-task-modal.component';
import { ImmoTaskAssetUploader } from './task/create-edit-task/immo-task-asset-uploader/immo-task-asset-uploader.component';
import { EmployeeTourEditModalComponent } from './tour/tour-page/employee-tour-edit-modal/employee-tour-edit-modal.component';
import { EmployeeTourMapComponent } from './tour/tour-page/employee-tour-edit-modal/employee-tour-map/employee-tour-map.component';
import { EmployeeTourListComponent } from './tour/tour-page/employee-tour-list/employee-tour-list.component';
import { EmployeeTourComponent } from './tour/tour-page/employee-tour-list/employee-tour/employee-tour.component';
import { ImmoMapPopupInfoComponent } from './tour/tour-page/immo-map/immo-map-popup/immo-map-popup-info/immo-map-popup-info.component';
import { ImmoMapPopupComponent } from './tour/tour-page/immo-map/immo-map-popup/immo-map-popup.component';
import { ImmoMapComponent } from './tour/tour-page/immo-map/immo-map.component';
import { PreviewMarkerPopupComponent } from './tour/tour-page/immo-map/preview-marker-popup/preview-marker-popup.component';
import { TourPreviewSelectorModalComponent } from './tour/tour-page/immo-map/tour-preview-selector-modal/tour-preview-selector-modal.component';
import { MarkerMultiselectModal } from './tour/tour-page/immo-map/marker-multiselect-modal/marker-multiselect-modal.component';
import { ImmoTableComponent } from './tour/tour-page/immo-table/immo-table.component';
import { TourPageComponent } from './tour/tour-page/tour-page.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    AppPipesModule,
    MatPaginatorModule,
    MatBadgeModule,
    MatMenuModule,
    CollapseModule,
    ClipboardModule,
    NgMapsCoreModule,
    NgMapsGoogleModule,
    MatAutocompleteModule,
    MatTableModule,
  ],
  exports: [
    ImmoIpComponent,
    NewImmoOverviewComponent,
    PrintImmoOverviewComponent,
    ImmoPrintTablesComponent,
    TextImmoOverviewComponent,
    DesignImmoOverviewComponent,
    AppointmentImmoOverviewComponent,
    NonExecutedImmoOverviewComponent,
    CompletedImmoOverviewComponent,
    TourPageComponent,
    ImmoMapComponent,
    ImmoMapPopupComponent,
    ImmoMapPopupInfoComponent,
    PreviewMarkerPopupComponent,
    MarkerMultiselectModal,
    EmployeeTourListComponent,
    EmployeeTourComponent,
    EmployeeTourEditModalComponent,
    EmployeeTourMapComponent,
    ImmoTableComponent,
    ImmoIPPlacerSubProjectSearchComponent,
    ImmoIPPlacerTourViewComponent,
    ImmoIPPlacerTourListComponent,
    ImmoIPPlacerTourRouteComponent,
    ImmoIPPlacerTourRouteMapComponent,
    ImmoIPPlacerTourItemDetailComponent,
    ImmoIPPlacerTourItemDetailNotExecutedModalComponent,
    ImmoIPPlacerTourItemDetailNotExecutedAssetsComponent,
    ImmoIPPlacerImmoTaskDetailComponent,
    ImmoIPPlacerImmoTaskHeader,
    ImmoIPPlacerImmoTaskExecutionAssetsComponent,
    StudioImmoOverviewComponent,
    DelayedImmoOverviewComponent,
    ImmoBillingOverviewComponent,
    ImmoBillingDetailComponent,
    ImmoIPPlacerProjectCompletionComponent,
    ImmoIPPlacerProjectCompletionPicturesComponent,
    ImmoRedirectLandingPageComponent,
    TourPreviewSelectorModalComponent,
    AppointmentNewImmoOverviewComponent,
    AppointmentNoTourImmoOverviewComponent,
    ImmoTaskOverviewComponent,
    CreateEditTaskModalComponent,
    ImmoTaskAssetUploader,
    CompletedAssignmentModalComponent,
    ImmoJobOverviewComponent,
    ImmoJobYearOverviewComponent,
    ImmoJobClientOverviewComponent,
  ],
  declarations: [
    ImmoIpComponent,
    NewImmoOverviewComponent,
    PrintImmoOverviewComponent,
    ImmoPrintTablesComponent,
    TextImmoOverviewComponent,
    DesignImmoOverviewComponent,
    AppointmentImmoOverviewComponent,
    NonExecutedImmoOverviewComponent,
    CompletedImmoOverviewComponent,
    TourPageComponent,
    ImmoMapComponent,
    ImmoMapPopupComponent,
    ImmoMapPopupInfoComponent,
    PreviewMarkerPopupComponent,
    MarkerMultiselectModal,
    EmployeeTourListComponent,
    EmployeeTourComponent,
    EmployeeTourEditModalComponent,
    EmployeeTourMapComponent,
    ImmoTableComponent,
    ImmoIPPlacerSubProjectSearchComponent,
    ImmoIPPlacerTourViewComponent,
    ImmoIPPlacerTourListComponent,
    ImmoIPPlacerTourRouteComponent,
    ImmoIPPlacerTourRouteMapComponent,
    ImmoIPPlacerTourItemDetailComponent,
    ImmoIPPlacerTourItemDetailNotExecutedModalComponent,
    ImmoIPPlacerTourItemDetailNotExecutedAssetsComponent,
    ImmoIPPlacerImmoTaskDetailComponent,
    ImmoIPPlacerImmoTaskHeader,
    ImmoIPPlacerImmoTaskExecutionAssetsComponent,
    StudioImmoOverviewComponent,
    DelayedImmoOverviewComponent,
    ImmoBillingOverviewComponent,
    ImmoBillingDetailComponent,
    ImmoIPPlacerProjectCompletionComponent,
    ImmoIPPlacerProjectCompletionPicturesComponent,
    ImmoRedirectLandingPageComponent,
    TourPreviewSelectorModalComponent,
    AppointmentNewImmoOverviewComponent,
    AppointmentNoTourImmoOverviewComponent,
    ImmoTaskOverviewComponent,
    CreateEditTaskModalComponent,
    ImmoTaskAssetUploader,
    CompletedAssignmentModalComponent,
    ImmoJobOverviewComponent,
    ImmoJobYearOverviewComponent,
    ImmoJobClientOverviewComponent,
  ],
})
export class ImmoIpModule {}
